import { Episode } from 'resources';
import EpisodeSchema from 'resources/episode/schema';
import updateEntity from 'app/entity/actions/update';
import store from 'app/store';

export default function updateEpisodeContentLengthAndUrl(episodeId, contentLength, url) {
  const state = store.get().getState();
  const episodeEntity = state.episode.get(episodeId);
  const episodeState = episodeEntity.getState();
  const schema = new EpisodeSchema(episodeState);
  const update = schema.merge({
    contentLength,
    mediaURL: url,
  });

  updateEntity(Episode, update);
}
